var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgDelete = function SvgDelete(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25 4h-5V2.894C20 1.298 18.74 0 17.191 0H10.81C9.259 0 8 1.298 8 2.895V4H3a1 1 0 1 0 0 2h1v16.902C4 25.712 6.349 28 9.235 28h9.53C21.65 28 24 25.713 24 22.902V6h1a1 1 0 1 0 0-2M10 2.894c0-.493.362-.894.809-.894h6.382c.447 0 .809.401.809.894V4h-8zm12 20.008C22 24.61 20.549 26 18.765 26h-9.53C7.451 26 6 24.61 6 22.902V6h16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11 23a1 1 0 0 1-1-1V10a1 1 0 1 1 2 0v12a1 1 0 0 1-1 1M17 23a1 1 0 0 1-1-1V10a1 1 0 1 1 2 0v12a1 1 0 0 1-1 1"
  })));
};
export default SvgDelete;